// extracted by mini-css-extract-plugin
module.exports = {"block":"ConsentsBlock_block__18wa0","block__cardError":"ConsentsBlock_block__cardError__3CNOJ","block__cardErrorText":"ConsentsBlock_block__cardErrorText__3vm02"};